import {
  CRUD,
  ADD_PRESENTER,
  DELETE_PRESENTER,
  CHANGE_PRESENTER,
  UPDATE_EVENT_CRUD,
  UPDATE_FREE_CLASS_CRUD,
  DELETE_INSTRUCTOR,
  ADD_INSTRUCTOR,
  CHANGE_INSTRUCTOR,
} from "../constants";
import nextId from "react-id-generator";
import moment from "moment";

export const eventCrudInitialState = {
  type: "seminar",
  title: "",
  cover_image: null,
  date: null,
  start_time: { time: null, sufix: null },
  end_time: { time: null, sufix: null },
  overview: "",
  category_id: [],
  tags: [],
  link: "",
  url: "",
  presenters: [
    {
      presenter_id: nextId(),
      name: "",
      position: "",
      bio_raw: "",
      avatar: "",
      organization: "",
    },
  ],
  instructor: [
    {
      presenter_id: nextId(),
      name: "",
      position: "",
      bio_raw: "",
      avatar: "",
      organization: "",
    },
  ],
};

export const eventsCrud = (
  formData = eventCrudInitialState,
  { type, payload = {} }
) => {
  const { event, eventType } = payload;
  switch (type) {
    case UPDATE_EVENT_CRUD:
      return { ...payload };
    case CRUD:
      switch (eventType) {
        case "change":
          if (
            event.target.name === "start_time" ||
            event.target.name === "end_time"
          ) {
            if (
              event.target.name === "start_time" &&
              event.target.value !== null
            ) {
              if (moment(event.target.value).format("HH") < 12)
                return {
                  ...formData,
                  [event.target.name]: {
                    ...[event.target.name],
                    time: event.target.value,
                    sufix: "AM",
                  },
                  end_time: {
                    time: moment().set({ hour: 23, minute: 59 }),
                    sufix: moment().set({ hour: 23, minute: 59 }).format("A"),
                  },
                };
              else
                return {
                  ...formData,
                  [event.target.name]: {
                    ...[event.target.name],
                    time: event.target.value,
                    sufix: "PM",
                  },
                  end_time: {
                    time: moment().set({ hour: 23, minute: 59 }),
                    sufix: moment().set({ hour: 23, minute: 59 }).format("A"),
                  },
                };
            } else if (event.target.value === null) {
              return {
                ...formData,
                [event.target.name]: {
                  ...[event.target.name],
                  time: event.target.value,
                  sufix: "",
                },
              };
            } else if (moment(event.target.value).format("HH") < 12) {
              return {
                ...formData,
                [event.target.name]: {
                  ...[event.target.name],
                  time: event.target.value,
                  sufix: "AM",
                },
              };
            } else {
              return {
                ...formData,
                [event.target.name]: {
                  ...[event.target.name],
                  time: event.target.value,
                  sufix: "PM",
                },
              };
            }
          } else {
            return { ...formData, [event.target.name]: event.target.value };
          }
        default:
          break;
      }
      return formData;
    case DELETE_PRESENTER:
      return {
        ...formData,
        presenters: formData.presenters.filter(
          (_) => _.presenter_id !== payload
        ),
        instructor: formData.instructor.filter(
          (_) => _.presenter_id !== payload
        ),
      };
    case ADD_PRESENTER:
      return {
        ...formData,
        presenters: [
          ...formData?.presenters,
          {
            presenter_id: nextId(),
            name: "",
            position: "",
            bio_raw: "",
            avatar: "",
            organization: "",
          },
        ],
        instructor: [
          ...formData?.instructor,
          {
            presenter_id: nextId(),
            name: "",
            position: "",
            bio_raw: "",
            avatar: "",
            organization: "",
          },
        ],
      };
    case CHANGE_PRESENTER:
      return {
        ...formData,
        presenters: formData.presenters.map((_) => {
          if (_.presenter_id === payload.id)
            return { ..._, [event.target.name]: event.target.value };
          return _;
        }),
        instructor: formData.instructor.map((_) => {
          if (_.presenter_id === payload.id)
            return { ..._, [event.target.name]: event.target.value };
          return _;
        }),
      };
    case DELETE_INSTRUCTOR:
      return {
        ...formData,
        instructor: formData.instructor.filter(
          (_) => _.presenter_id !== payload
        ),
      };
    case ADD_INSTRUCTOR:
      return {
        ...formData,
        instructor: [
          ...formData.instructor,
          {
            presenter_id: nextId(),
            name: "",
            position: "",
            bio_raw: "",
            avatar: "",
            organization: "",
          },
        ],
      };
    case CHANGE_INSTRUCTOR:
      return {
        ...formData,
        instructor: formData.instructor.map((_) => {
          if (_.presenter_id === payload.id)
            return { ..._, [event.target.name]: event.target.value };
          return _;
        }),
      };
    case UPDATE_FREE_CLASS_CRUD:
      return { ...payload };
    default: {
      return formData;
    }
  }
};
